import React from 'react';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import IconButtonWithTooltip from './IconButtonWithTooltip';

const AddButton = ({onClick, text=null}) => {
    return <IconButtonWithTooltip text={text} translationId='button.add.entry' icon={faPlus} onClick={onClick} type="Button"/>
};

export default AddButton;
